import type {ReactAction} from '@netx/core/bootstrap';
import {faClone} from '@fortawesome/pro-solid-svg-icons';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {cartActionManageRelationshipsDelink} from './cart-manage-relationships-delink';
import {cartActionManageRelationshipsLink} from './cart-manage-relationships-link';

/**
 * Manage cart asset relationships
 * @param params
 * @returns Action
 */
export const cartActionManageRelationships = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-relationships',
	cb: () => {},
	icon: faClone,
	get label() {
		return CART_CURRENT_ACTION_LABELS.RELATIONSHIPS;
	},
	children: [
		cartActionManageRelationshipsDelink(),
		cartActionManageRelationshipsLink(),
	],
	...params,
});

export default cartActionManageRelationships;
